<template>
  <div>
    <nav-breadcrumb :menu="[{label: '贷款作废'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="可作废" name="Ready" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="已作废" name="Rejected" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "VoidFinancingList",
      data(){
        return {
          applicationStatus: 'Ready',
          page: 1,
          pageSize: 20,
          listData: {},
          filters: {
            labelWidth: '150px',
            form: {
              fi__transactionNo:'',
              c__customerName:'',
              c__customerContactNo:'',
              fi__transactionDate:[],
            },
            columns: [
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',

              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName',

              },
              /*{
                label: '客户手机号',
                component: 'el-input',
                field: 'c__customerContactNo',

              },*/
              {
                label: '申请日期',
                component: 'date-range-picker',
                field: 'fi__transactionDate',
                op: ['gteq', 'lteq'],
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '客户姓名',
              field: 'c__customerName'
            },
           /* {
              label: '客户手机号',
              field: 'c__customerContactNo'
            },*/
            {
              label: '贷款金额',
              field: 'fi__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '合同利率(%)',
              field: 'fi__interestRate',
              formatter: function (r,c,v) {
                return v+'%'+'('+Status2CN(r.fi__interestType)+')'
              }
            },
            {
              label: '留存收益率(%)',
              field: 'dfi__interestRate',
              formatter: function (r,c,v) {
                return v+'%'+'('+Status2CN(r.dfi__interestType)+')'
              }
            },
            {
              label: '开始日期',
              field: 'fi__startDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '结束日期',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '申请日期',
              field: 'fi__transactionDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '作废',
                  class: 'el-icon-error',
                  clickHandler: (index, row) => {
                    this.voidFinancing(row.fi__transactionId)
                  },
                  conditions: row=> {
                    return row.fi__transactionStatus=='Ready'

                  }
                },
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'CustomerFinancingDetailView',
                      query: {
                        'transactionId': row.fi__transactionId,
                      }
                    })
                  },
                  conditions: row=> {
                    return row.fi__transactionStatus=='Rejected'

                  }
                },

              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.fi.transactionStatus' : this.applicationStatus,
              'xlist.search.fi.transactionStatus.op' : 'in',
              'xlist.sort.dataField': 'fi.startDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
      },
      methods:{
        getData: function () {
          if(this.applicationStatus=='Ready'){
            xhr.getFinancingReadyForPayment(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.listData = res.data
                } catch (e) {

                }
              })
          }
          if(this.applicationStatus=='Rejected'){
            xhr.getFinancingFangList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.listData = res.data
                } catch (e) {

                }
              })
          }

        },
        voidFinancing:function (transactionId) {
          this.$confirm("确认要作废当前这笔贷款吗？").then(()=> {
            xhr.voidFinancing(
              {
                'fi.transactionId':transactionId
              },
              res=> {
                try{
                  if(res.data.status == 'success') {
                    this.getData()
                  }else{

                    this.$message.error(res.data.msgs[0].text)
                  }
                }catch (e) {

                  this.$message.error(error.msgs[0].text)

                }
              }
            )
          })
            .catch(()=> {

            })

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/VoidFinancingList.vue